import { IListaModeloRenegociacaoGrupo } from "../../../Interfaces/Cobranca/ModeloRenegociacaoGrupo/IModeloRenegociacaoGrupo";
import {
    DeletarModeloRenegociacaoGrupoService,
    InserirModeloRenegociacaoGrupoService,
    ListarModeloRenegociacaoGrupoService,
    ListarModeloRenegociacaoService,
} from "../../../Services/ModeloRenegociacaoGrupo";
import { Controller } from "../../Controller";

export async function ListarModeloRenegociacaoController() {
    return Controller(ListarModeloRenegociacaoService());
}

export async function ListarModeloRenegociacaoGrupoController() {
    return Controller(ListarModeloRenegociacaoGrupoService());
}

export async function InserirModeloRenegociacaoGrupoController(
    resquestBody: IListaModeloRenegociacaoGrupo
) {
    return Controller(InserirModeloRenegociacaoGrupoService(resquestBody));
}

export async function DeletarModeloRenegociacaoGrupoController(
    idModeloRenegociacaoGrupo: number
) {
    return Controller(
        DeletarModeloRenegociacaoGrupoService(idModeloRenegociacaoGrupo)
    );
}
